// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textcolor {
  color: #5ea1d8;
}

.item .img {
  height: 150px !important;
  background-color: lightgray;
}

p {
  margin: 0px;
}

.zoom:hover {
  border-radius: 5px;
  transform: scale(1.1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.owl-carousel .owl-nav button.owl-next,
.owl-carousel .owl-nav button.owl-prev,
.owl-carousel button.owl-dot {
  font-size: 55px !important;
}

.owl-theme .owl-nav [class*=owl-] {
  font-size: 55px !important;
}

button span {
  font-size: 55px;
}

.owl-nav {
  display: none;
}

.mat-badge-content {
  background: #5ea1d8;
}

.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  overflow: hidden;
  z-index: 100;
}

.bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.uni-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.uni-wrapper P {
  flex: 1;
}

.mat-sidenav-content h3 {
  margin: 0px;
}
.mat-sidenav-content h3 a {
  margin: 0px;
}

/* new common design add*/
.flobycategoryadd .user-pro .flowbycategory-row {
  width: 100%;
  justify-content: flex-start;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
  width: 15.6%;
  width: 15.361%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  margin-bottom: 15px;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item {
  overflow: hidden;
  background: #fff;
  border: 1px solid #dddddd;
  margin: 0px;
  margin-right: 0px;
  margin-bottom: 0px;
  height: 100%;
  position: relative;
  padding: 10px;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item > div {
  margin: 0px !important;
  height: 150px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item p {
  display: -webkit-box;
  /* -webkit-line-clamp: 2; */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 35px !important;
  white-space: normal;
  word-break: break-word;
  display: flex;
  align-items: flex-start;
  margin-top: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .uni-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .with-icon {
  width: 100%;
  font-family: "Raleway";
  display: flex;
  align-items: center;
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile .item .with-icon img {
  object-fit: cover;
  height: 40px !important;
  border: 0px;
  margin: 0px !important;
}
.flobycategoryadd .user-pro .flowbycategory-row video.video-display[poster] {
  height: 100% !important;
  padding-bottom: 12%;
  max-height: 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  text-align: center;
  cursor: pointer;
  max-height: 150px !important;
}
.flobycategoryadd .mat-sidenav-content {
  background: #efeeee !important;
  min-height: 89vh !important;
  padding: 2rem 3rem !important;
  padding-top: 0px !important;
}

@media only screen and (max-width: 992px) and (min-width: 768px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 23% !important;
    width: 23% !important;
    margin: 1% !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .flobycategoryadd .mat-sidenav-content {
    background: #efeeee !important;
    min-height: 89vh !important;
    padding: 2rem 10px !important;
    padding-top: 0px !important;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 31.3% !important;
    width: 31.3% !important;
    margin: 1%;
  }
}
/* Collaboration "name and @coauthor" inline text */
.collab-sep {
  color: #888;
  font-weight: 400;
  font-size: 11px;
}

.collab-coname {
  font-weight: 500;
  color: #555;
  cursor: pointer;
}
.collab-coname:hover {
  text-decoration: underline;
}

@media screen and (max-width: 460px) {
  .flobycategoryadd .user-pro .flowbycategory-row .flowbycategory-tile {
    max-width: 48% !important;
    width: 48% !important;
    margin: 1%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/flow-by-category/flow-by-category.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AACA;EACE,wBAAA;EACA,2BAAA;AAEF;;AAAA;EACE,WAAA;AAGF;;AAAA;EACE,kBAAA;EAGA,qBAAA;EACA,qFAAA;AACF;;AAEA;;;EAGE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,YAAA;EAEA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;AACF;AAAE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAEJ;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AACF;AAAE;EACE,OAAA;AAEJ;;AAGE;EACE,WAAA;AAAJ;AACI;EACE,WAAA;AACN;;AAIA,yBAAA;AAGE;EACE,WAAA;EACA,2BAAA;AAHJ;AAII;EACE,YAAA;EACA,cAAA;EAEA,iBAAA;EACA,kBAAA;EACA,mBAAA;AAHN;AAIM;EAEE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAHR;AAIQ;EACE,sBAAA;EACA,wBAAA;AAFV;AAIQ;EACE,oBAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,0BAAA;AAFV;AAMQ;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAJV;AAMQ;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;AAJV;AAKU;EAEE,iBAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;AAHZ;AAQI;EACE,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AANN;AASE;EACE,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;AAPJ;;AAWA;EAIQ;IACE,yBAAA;IACA,qBAAA;IACA,qBAAA;EAXR;AACF;AAgBA;EAEI;IACE,8BAAA;IACA,2BAAA;IACA,6BAAA;IACA,2BAAA;EAfJ;AACF;AAkBA;EAIQ;IACE,2BAAA;IACA,uBAAA;IACA,UAAA;EAnBR;AACF;AAwBA,mDAAA;AACA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAtBF;AAuBE;EAAU,0BAAA;AApBZ;;AAuBA;EAIQ;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;EAvBR;AACF","sourcesContent":[".textcolor {\n  color: #5ea1d8;\n}\n.item .img {\n  height: 150px !important;\n  background-color: lightgray;\n}\np {\n  margin: 0px;\n}\n\n.zoom:hover {\n  border-radius: 5px;\n  // -ms-transform: scale(1.2); /* IE 9 */\n  // -webkit-transform: scale(1.5); /* Safari 3-8 */\n  transform: scale(1.1);\n  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel button.owl-dot {\n  font-size: 55px !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"] {\n  font-size: 55px !important;\n}\n\nbutton span {\n  font-size: 55px;\n}\n\n.owl-nav {\n  display: none;\n}\n\n.mat-badge-content {\n  background: #5ea1d8;\n}\n.div1 {\n  height: 50px;\n\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n}\n\n.bundleIcon {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.uni-wrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  P {\n    flex: 1;\n  }\n}\n\n.mat-sidenav-content {\n  h3 {\n    margin: 0px;\n    a {\n      margin: 0px;\n    }\n  }\n}\n\n/* new common design add*/\n\n.flobycategoryadd {\n  .user-pro .flowbycategory-row {\n    width: 100%;\n    justify-content: flex-start;\n    .flowbycategory-tile {\n      width: 15.6%;\n      width: 15.361%;\n      // margin-right: 1%;\n      margin-left: 0.5%;\n      margin-right: 0.5%;\n      margin-bottom: 15px;\n      .item {\n        // width: 100% !important;\n        overflow: hidden;\n        background: #fff;\n        border: 1px solid #dddddd;\n        margin: 0px;\n        margin-right: 0px;\n        margin-bottom: 0px;\n        height: 100%;\n        position: relative;\n        padding: 10px;\n        &>div {\n          margin: 0px !important;\n          height:150px !important;\n        }\n        p {\n          display: -webkit-box;\n          /* -webkit-line-clamp: 2; */\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          height: 35px !important;\n          white-space: normal;\n          word-break: break-word;\n          display: flex;\n          align-items: flex-start;\n          margin-top: 0px !important;\n          &:last-of-type {\n          }\n        }\n        .uni-wrapper {\n          display: flex;\n          width: 100%;\n          align-items: center;\n        }\n        .with-icon {\n          width: 100%;\n          font-family: \"Raleway\";\n          display: flex;\n          align-items: center;\n          margin: 0px !important;\n          img {\n            -o-object-fit: cover;\n            object-fit: cover;\n            height: 40px !important;\n            border: 0px;\n            margin: 0px !important;\n          }\n        }\n      }\n    }\n    video.video-display[poster] {\n      height: 100% !important;\n      padding-bottom: 12%;\n      max-height: 100% !important;\n      max-width: 100% !important;\n      width: 100% !important;\n      text-align: center;\n      cursor: pointer;\n      max-height: 150px !important;\n    }\n  }\n  .mat-sidenav-content {\n    background: #efeeee !important;\n    min-height: 89vh !important;\n    padding: 2rem 3rem !important;\n    padding-top: 0px !important;\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 23% !important;\n          width: 23% !important;\n          margin: 1% !important;\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .flobycategoryadd {\n    .mat-sidenav-content {\n      background: #efeeee !important;\n      min-height: 89vh !important;\n      padding: 2rem 10px !important;\n      padding-top: 0px !important;\n    }\n  }\n}\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 31.3% !important;\n          width: 31.3% !important;\n          margin: 1%;\n        }\n      }\n    }\n  }\n}\n/* Collaboration \"name and @coauthor\" inline text */\n.collab-sep {\n  color: #888;\n  font-weight: 400;\n  font-size: 11px;\n}\n\n.collab-coname {\n  font-weight: 500;\n  color: #555;\n  cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n\n@media screen and (max-width: 460px) {\n  .flobycategoryadd {\n    .user-pro {\n      .flowbycategory-row {\n        .flowbycategory-tile {\n          max-width: 48% !important;\n          width: 48% !important;\n          margin: 1%;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
